export function getQueryString(key) {
    const reg = new RegExp(key + "=([^&#]*)", "i");
    const value = reg.exec(location.href);
    if (value == null) return null;
    return decodeURI(value[1]);
}